/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadset = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 22h-7v-9h5v-1c0-4.411-3.589-8-8-8s-8 3.589-8 8v5h2v-2h7v6H6v-2H2v-7C2 6.486 6.486 2 12 2s10 4.486 10 10zm-2-7h-3v5h3zm-9 2H8v2h3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHeadset as Headset };
